import { Pipe, PipeTransform } from '@angular/core';

import { IBomModel } from '../../prisma-xs/models/bom.model';
import { allBomElementsAreSelected } from '../../enclosure/helpers/product.helper';

@Pipe({
    name: 'bomPriwiringFilterSelected',
    standalone: false
})
export class BomPriwiringFilterSelectedPipe implements PipeTransform {

  transform(bomModels: IBomModel[],
            selectedItems: number[],
            bomModelsAccessories: IBomModel[],
            selectedItemsAccessories: number[]): boolean {
    const allPrewiredBomModels = bomModels?.filter(bomModel => bomModel.article.deliverToPanelBuilder);
    const allPrewiredBomAccessoriesModels = bomModelsAccessories?.filter(bomModel => bomModel.article.deliverToPanelBuilder);

    return allBomElementsAreSelected(allPrewiredBomModels, selectedItems, allPrewiredBomAccessoriesModels, selectedItemsAccessories);
  }

}
